export default {
    cart: [],
    currentProduct:[],
    shopConfigData:[],
}